export const mountHooks = (router, hooks) => {
  for (const i in hooks) {
    router[i](hooks[i])
  }
}
